import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { DrawoutApps } from 'src/app/shared/enum/common/DrawoutApps';
import { UserDetailService } from '../../services/user-detail.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit, OnDestroy {

  userData: any;
  subscription1: Subscription;
  timer: any;
  showReload = false;
  showInactiveOrganisation = false;
  message = '';
  showMessage = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private request: DoHttpService,
    private userDetailService: UserDetailService
  ) {
    this.authService.completeAuthentication().then(res => {
      this.userData = JSON.parse(sessionStorage.getItem('userLogged'));
      this.subscription1 = this.request.get(`${this.request.clientBaseUrl}/login-details`).subscribe(result => {
        sessionStorage.xCompuse = result.xCompuse;
        sessionStorage.fullName = result.fullName ? result.fullName : '';
        sessionStorage.organisationCode = result.organisationCode;
        this.userDetailService.setUser(result, false);

        const redirectUrl = this.getRouteToNavigate(result);
        if (redirectUrl) {
          this.router.navigate([redirectUrl])
        } else {
          this.message = 'No licence Available';
          this.showMessage = true;
        }

      });
    },
      err => {
        this.router.navigate(['./']);
      });
  }

  ngOnInit(): void {
    this.showReload = false;
    this.setTimer();
  }

  ngOnDestroy() {
    this.subscription1 ? this.subscription1.unsubscribe() : "";
    clearTimeout(this.timer);
  }

  setTimer() {
    this.timer = setTimeout(() => {
      this.showReload = true;
    }, 8000);
  }

  refreshPage() {
    this.router.navigate(['']);
  }

  getRouteToNavigate(result) {
    if (sessionStorage.getItem('redirectUrl')) {
      const url = sessionStorage.getItem('redirectUrl');
      sessionStorage.removeItem('redirectUrl');
      return url;
    } else {
      switch (result.appLastSession) {
        case DrawoutApps.Lite:
          return '/sketch';
        case DrawoutApps.Zen:
          return '/drawout-app';
        case DrawoutApps.Pro:
          return '/workspaces/' + result.lastSessionId + '/projects';
        default:
          return '/home';
      }
    }
  }

}
